import React from 'react';

// Styles & Assets
import styles from './NavbarWrapper.module.css';

// Interfaces
import { ReactNode } from 'react';

// NavbarWrapper: It provides a wrapper with standarized styles
// for all the different Navbars. Received props:
//  -children: it renders all children components provided.
const NavbarWrapper: React.FC<{
    children: ReactNode
}> = ({ children }) => {

    return (
        <nav className={styles.NavbarWrapper}>
            {children}
        </nav>
    );
};

export default NavbarWrapper;